import React from 'react';

type DisclaimerType = string;

interface ConsentDisclaimerProps {
  type?: DisclaimerType;
  classnames?: string;
}

const ConsentDisclaimer: React.FC<ConsentDisclaimerProps> = ({
  type = 'default',
  classnames = '',
}) => {
  const handleTermsClick = (event: React.MouseEvent<HTMLSpanElement>) => {
    event.preventDefault();
    const termsUrl = process.env.ICM_URL ? `${process.env.ICM_URL}/terms-of-use` : '/terms-of-use';
    window.open(termsUrl, '_blank', 'noopener,noreferrer');
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleTermsClick(event as unknown as React.MouseEvent<HTMLSpanElement>);
    }
  };

  return (
    <p 
      className={`text-xs text-neutral-500 font-medium leading-[16.8px] ${classnames}`}
      data-testid="consent-disclaimer"
    >
      By proceeding, I accept the{' '}
      <span
        className="underline cursor-pointer hover:text-neutral-700 transition-colors"
        onClick={handleTermsClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        data-testid="terms-link"
      >
        Terms & Conditions
      </span>
      {type === 'phone' || type === 'phoneotp' 
        ? ', and agree to receive messages such as OTPs & important updates on WhatsApp.'
        : '.'}
    </p>
  );
};

export default ConsentDisclaimer;